import { ajax } from '@square/dashboard-utilities/utils/xhr';
import { Promise } from 'rsvp';
export const fileMocks = {
  convertUrlToImageFile(url) {
    return new Promise((resolve, reject) => {
      ajax(url, {
        xhrFields: {
          responseType: 'blob'
        }
      }).then(data => {
        const fileReader = new FileReader();
        fileReader.onload = () => {
          const filename = url.split('/').pop();
          resolve({
            file: new File([data], filename),
            data: fileReader.result
          });
        };
        fileReader.onerror = () => {
          reject(new Error(`FileReader error: ${fileReader.error}`));
        };
        fileReader.onabort = () => {
          reject(new Error('FileReader aborted.'));
        };
        fileReader.readAsDataURL(data);
      }).catch(error => {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject({
          convertUrlToImageFileError: error
        });
      });
    });
  }
};
export function convertUrlToImageFile(url) {
  return fileMocks.convertUrlToImageFile(url);
}